import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { selectEmployeeByUuid } from '../payroll.selectors'
import { fetchSingleEmployee } from '../payrollActions'
import { JobPayTab } from './JobPayTab'
import { EmployeeDocumentsTab } from './EmployeeDocumentsTab'

import { OnboardingCTA } from './OnboardingCTA'
import { Text, Tab, Badge, Card, Loader, Icon, Breadcrumb } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'

export const PayrollEmployee = () => {
  const dispatch = useAppDispatch()
  const { uuid } = useParams()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const employee = useReselector(selectEmployeeByUuid, uuid)

  const [activeIndex, setActiveIndex] = useState(
    searchParams.get('tab') === 'documents' ? 1 : 0
  )

  useEffect(() => {
    if (uuid) {
      dispatch(fetchSingleEmployee(uuid))
    }
  }, [dispatch, uuid])

  const panes = useMemo(
    () =>
      uuid
        ? [
            {
              menuItem: 'Job and Pay',
              render: () => <JobPayTab uuid={uuid} />,
            },
            {
              menuItem: 'Documents',
              render: () => <EmployeeDocumentsTab uuid={uuid} />,
            },
          ]
        : [],
    [uuid]
  )

  return (
    <div id="employee-details">
      <Card>
        {!employee && (
          <div className="flex justify-center items-center h-full">
            <Loader />
          </div>
        )}
        {employee && (
          <div className="flex flex-col gap-6">
            <Breadcrumb>
              <Breadcrumb.List>
                <Breadcrumb.Item>
                  <Breadcrumb.Link
                    onClick={() => {
                      navigate('/payroll/employees')
                    }}
                  >
                    <Icon icon={faArrowLeft} />
                    Back to team
                  </Breadcrumb.Link>
                </Breadcrumb.Item>
              </Breadcrumb.List>
            </Breadcrumb>

            <div className="flex items-center gap-2">
              <Text variant={TypographyStyles.H1}>
                {employee.first_name} {employee.last_name}
              </Text>
              {!employee.onboarded && (
                <Badge variant="default">Onboarding</Badge>
              )}
            </div>

            <OnboardingCTA teamMemberUuid={employee.uuid} isEmployee />

            <Tab
              panes={panes}
              defaultActiveIndex={activeIndex}
              onTabClick={(index) => setActiveIndex(index)}
            />
          </div>
        )}
      </Card>
    </div>
  )
}
